import { Link as RouterLink } from 'react-router-dom';
import {
  TextField,
  Box,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Avatar,
  Link,
  Typography,
  IconButton,
  Button,
  Chip,
  Grid
} from '@material-ui/core';
import {
  Delete as DeleteIcon,
  FilterList as FilterListIcon,
  Sort as SortIcon,
  Category as CategoryIcon,
  Search as SearchIcon,
  Person as PersonIcon
} from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Scrollbar from '../../Scrollbar';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import ArchiveIcon from '@mui/icons-material/Archive';
import { usersApi } from '../../../api/usersApi';

const AVATAR_GRADIENTS = [
  ['#3b82f6', '#1d4ed8'],
  ['#8b5cf6', '#6d28d9'],
  ['#06b6d4', '#0e7490'],
  ['#10b981', '#047857'],
  ['#f59e0b', '#b45309'],
  ['#ec4899', '#be185d'],
  ['#6366f1', '#4338ca'],
  ['#14b8a6', '#0f766e'],
];

const hashString = (str = '') => {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

const SERVICE_COLORS = {
  0: ['#3b82f6', 'rgba(59, 130, 246, 0.1)'],
  2: ['#8b5cf6', 'rgba(139, 92, 246, 0.1)'],
  3: ['#10b981', 'rgba(16, 185, 129, 0.1)'],
  4: ['#f59e0b', 'rgba(245, 158, 11, 0.1)'],
  999: ['#64748b', 'rgba(100, 116, 139, 0.12)'],
};

const getServiceColor = (id) => SERVICE_COLORS[id] || ['#6366f1', 'rgba(99, 102, 241, 0.1)'];

export const serviceLabelMap = {
  0: 'Administrateur',
  2: 'Communication',
  3: 'Commercial',
  4: 'Suivi',
  999: 'Archivé',
};

export const getServiceLabel = (id) => (Object.prototype.hasOwnProperty.call(serviceLabelMap, id) ? serviceLabelMap[id] : String(id));

const sortOptions = [
  {
    label: 'Nom (A - Z)',
    value: 'lastname|asc'
  },
  {
    label: 'Nom (Z - A)',
    value: 'lastname|desc'
  }
];

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}

// eslint-disable-next-line no-unused-vars
const applyFilters = (customers, query, functionUser) => customers
  .filter((customer) => {
    let matches = true;
    customer.firstlastname = `${customer.firstname} ${customer.lastname}`;

    if (query) {
      const properties = ['firstlastname', 'functions'];
      let containsQuery = false;

      properties.forEach((property) => {
        if (customer[property].toLowerCase().includes(query.toLowerCase())) {
          containsQuery = true;
        }
      });

      if (!containsQuery) {
        matches = false;
      }
    }
    const functionUserKeys = Object.keys(functionUser);
    functionUserKeys.forEach((key) => {
      const value = functionUser[key];
      if (value && customer.functions !== key) {
        matches = false;
      }
    });
    return matches;
  });

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }

  return 0;
};

const applyPagination = (customers, page, limit) => customers
  .slice(page * limit, page * limit + limit);
const getComparator = (order, orderBy) => (order === 'desc'
  ? (a, b) => descendingComparator(a, b, orderBy)
  : (a, b) => -descendingComparator(a, b, orderBy));

const applySort = (customers, sort) => {
  const [orderBy, order] = sort.split('|');
  const comparator = getComparator(order, orderBy);
  const stabilizedThis = customers.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const newOrder = comparator(a[0], b[0]);

    if (newOrder !== 0) {
      return newOrder;
    }

    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
};

const UsersListTable = (props) => {
  const { users } = props;
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(0);
  const [sort, setSort] = useState(sortOptions[0].value);
  const [limit, setLimit] = useState(25);
  const functions = [];
  // eslint-disable-next-line array-callback-return
  users.map((user) => {
    if (!functions.find((el) => el === user.functions)) {
      functions.push(user.functions);
    }
  });

  function initFunctionUser() {
    const functionUserObj = {};

    functions.forEach((functionElt) => {
      functionUserObj[functionElt] = null;
    });
    functions.Toutes = null;
    return functionUserObj;
  }

  const [functionUser, setFunctionUser] = useState(initFunctionUser);

  const filteredUsers = applyFilters(users, query, functionUser);
  const sortedUsers = applySort(filteredUsers, sort);
  const paginatedUsers = applyPagination(sortedUsers, page, limit);
  const [selectedUsers, setSelectedUsers] = useState([]);
  // const selectedSomeUsers = selectedUsers.length > 0;
  // const selectedAllUsers = selectedUsers.length === paginatedUsers.length;
  const [currentFunctionUser, setCurrentFunctionUser] = useState('all');
  const [open, setOpen] = useState(false);
  const [userDelete, setUserDelete] = useState({});
  const [openArchive, setOpenArchive] = useState(false);
  const [userArchive, setUserArchive] = useState({});

  const functionUserOptions = [
    {
      label: 'Toutes',
      value: 'all'
    },
  ];
  // eslint-disable-next-line array-callback-return
  functions.map((functionElt) => {
    functionUserOptions.push({ label: functionElt, value: functionElt });
  });

  useEffect(() => {
    setFunctionUser(functionUser);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [functions.length]);

  const handleQueryChange = (event) => {
    setQuery(event.target.value);
    // pour remettre à la première page de résultats quand on fait une recherche
    setPage(0);
  };

  const handleSortChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setSort(value);
    } else {
      setSort(event.target.value);
      window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // const handleSelectAllUsers = (event) => {
  //   setSelectedUsers(event.target.checked
  //     ? paginatedUsers.map((user) => user.id)
  //     : []);
  // };

  const handleFunctionUserChange = (event, value) => {
    const tempFunctionUser = initFunctionUser();
    const updatedFunctionUser = {
      ...tempFunctionUser
    };
    if (typeof event.target === 'undefined') {
      if (value !== 'all') {
        updatedFunctionUser[value] = true;
      }
      setFunctionUser(updatedFunctionUser);
      setSelectedUsers([]);
      setCurrentFunctionUser(value);
    } else {
      if (event.target.value !== 'all') {
        updatedFunctionUser[event.target.value] = true;
      }

      setFunctionUser(updatedFunctionUser);
      setSelectedUsers([]);
      setCurrentFunctionUser(event.target.value);
    }
  };
  const dialogOpener = (index) => {
    setOpen(true);
    setUserDelete({ firstname: paginatedUsers[index].firstname, lastname: paginatedUsers[index].lastname, id: paginatedUsers[index].id });
  };

  const archiveDialogOpener = (index) => {
    setOpenArchive(true);
    setUserArchive({ firstname: paginatedUsers[index].firstname, lastname: paginatedUsers[index].lastname, id: paginatedUsers[index].id });
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleCloseArchiveDialog = () => {
    setOpenArchive(false);
  };

  const handleDeleteUser = async (userId) => {
    try {
      await usersApi.deleteUser(userId, localStorage.getItem('accessToken'));
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  const handleArchiveUser = async (userId) => {
    try {
      await usersApi.archiveUser(userId, localStorage.getItem('accessToken'));
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Box>
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        PaperProps={{ sx: { borderRadius: '20px', p: 1, maxWidth: 460 } }}
      >
        <DialogTitle sx={{ fontWeight: 800, color: '#1e293b' }}>
          Supprimer l&apos;utilisateur
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: '#475569' }}>
            Souhaitez-vous vraiment supprimer l&apos;utilisateur {userDelete.firstname} {userDelete.lastname} ? Cette action est irréversible.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleCloseDialog}
            sx={{
              backgroundColor: 'rgba(100,116,139,0.07)',
              color: '#475569',
              border: '1px solid rgba(100,116,139,0.18)',
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 700,
              px: 2.5
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={() => handleDeleteUser(userDelete.id)}
            variant="contained"
            sx={{
              background: 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)',
              color: '#fff',
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 700,
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
              px: 2.5,
              '&:hover': { background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)' }
            }}
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openArchive}
        onClose={handleCloseArchiveDialog}
        PaperProps={{ sx: { borderRadius: '20px', p: 1, maxWidth: 460 } }}
      >
        <DialogTitle sx={{ fontWeight: 800, color: '#1e293b' }}>
          Archiver l&apos;utilisateur
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: '#475569' }}>
            Souhaitez-vous vraiment archiver l&apos;utilisateur {userArchive.firstname} {userArchive.lastname} ? Vous pourrez toujours l&apos;utiliser comme source des ventes et le désarchiver plus tard.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleCloseArchiveDialog}
            sx={{
              backgroundColor: 'rgba(100,116,139,0.07)',
              color: '#475569',
              border: '1px solid rgba(100,116,139,0.18)',
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 700,
              px: 2.5
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={() => handleArchiveUser(userArchive.id)}
            variant="contained"
            sx={{
              background: 'linear-gradient(135deg, #f59e0b 0%, #b45309 100%)',
              color: '#fff',
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 700,
              boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
              px: 2.5,
              '&:hover': { background: 'linear-gradient(135deg, #d97706 0%, #92400e 100%)' }
            }}
          >
            Archiver
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ p: 3, bgcolor: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(10px)', borderBottom: '1px solid #e2e8f0' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <FilterListIcon sx={{ color: 'primary.main' }} />
          <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Filtres de recherche</Typography>
        </Box>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
                sx: { borderRadius: '12px', bgcolor: 'white' }
              }}
              onChange={handleQueryChange}
              placeholder="Chercher un utilisateur"
              value={query}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Trier par"
              name="sort"
              onChange={handleSortChange}
              select
              SelectProps={{ native: true }}
              value={sort}
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SortIcon color="action" />
                  </InputAdornment>
                ),
                sx: { borderRadius: '12px', bgcolor: 'white' }
              }}
            >
              {sortOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="Fonction"
              name="functionUser"
              onChange={handleFunctionUserChange}
              select
              SelectProps={{ native: true }}
              value={currentFunctionUser}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CategoryIcon color="action" />
                  </InputAdornment>
                ),
                sx: { borderRadius: '12px', bgcolor: 'white' }
              }}
            >
              {functionUserOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Box>
      <Scrollbar>
        <Box sx={{ minWidth: 700, px: 2 }}>
          <Table sx={{ borderCollapse: 'separate', borderSpacing: '0 8px', minWidth: 700 }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.75rem' }}>
                  Nom et Email
                </TableCell>
                <TableCell align="center" sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.75rem' }}>
                  Fonction
                </TableCell>
                <TableCell align="center" sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.75rem' }}>
                  Service
                </TableCell>
                <TableCell align="center" sx={{ borderBottom: 'none', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', fontSize: '0.75rem' }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedUsers.length === 0 && (
                <TableRow sx={{ backgroundColor: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                  <TableCell colSpan={4} align="center" sx={{ borderBottom: 'none', borderRadius: '12px', py: 5 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                      <PersonIcon sx={{ fontSize: 40, color: '#cbd5e1' }} />
                      <Typography variant="body2" sx={{ color: '#94a3b8', fontWeight: 600 }}>
                        Aucun utilisateur à afficher
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              <AnimatePresence>
                {/* eslint-disable-next-line no-unused-vars */}
                {paginatedUsers.map((user, index) => {
                  const isUserSelected = selectedUsers.includes(user.id);
                  const fullName = `${user.firstname.replace(/ /g, '')} ${user.lastname.replace(/ /g, '')}`;
                  const grad = AVATAR_GRADIENTS[hashString(fullName) % AVATAR_GRADIENTS.length];
                  const [serviceColor, serviceBg] = getServiceColor(user.id_service);

                  return (
                    <TableRow
                      component={motion.tr}
                      key={user.id}
                      selected={isUserSelected}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.2, delay: index * 0.02 }}
                      sx={{
                        backgroundColor: 'white',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        }
                      }}
                    >
                      <TableCell sx={{ borderBottom: 'none', borderRadius: '12px 0 0 12px' }}>
                        <Box
                          sx={{
                            alignItems: 'center',
                            display: 'flex'
                          }}
                        >
                          <Avatar
                            src={`data:image/png;base64,${user.photo}`}
                            {...stringAvatar(fullName)}
                            sx={{
                              height: 44,
                              width: 44,
                              borderRadius: '14px',
                              fontSize: '0.95rem',
                              fontWeight: 800,
                              color: '#fff',
                              boxShadow: `0 6px 16px ${grad[0]}40`,
                              border: '2px solid #fff',
                              background: `linear-gradient(135deg, ${grad[0]} 0%, ${grad[1]} 100%)`,
                            }}
                          />
                          <Box sx={{ ml: 1.5 }}>
                            <Link
                              component={RouterLink}
                              to={`/dashboard/user/${user.id}`}
                              variant="subtitle2"
                              sx={{ fontWeight: 700, color: '#1e293b', textDecoration: 'none', '&:hover': { color: '#3b82f6' } }}
                            >
                              {user.firstname}
                              {' '}
                              {user.lastname}
                            </Link>
                            <Typography
                              variant="body2"
                              sx={{ color: '#64748b' }}
                            >
                              {user.email}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="center" sx={{ borderBottom: 'none' }}>
                        <Chip
                          label={user.functions}
                          size="small"
                          sx={{ bgcolor: 'rgba(99, 102, 241, 0.1)', color: '#6366f1', fontWeight: 800, borderRadius: '8px' }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ borderBottom: 'none' }}>
                        <Chip
                          label={getServiceLabel(user.id_service)}
                          size="small"
                          sx={{ bgcolor: serviceBg, color: serviceColor, fontWeight: 800, borderRadius: '8px' }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ borderBottom: 'none', borderRadius: '0 12px 12px 0' }}>
                        <IconButton
                          component={RouterLink}
                          to={`/dashboard/user/${user.id}`}
                          sx={{
                            borderRadius: '10px',
                            color: '#3b82f6',
                            mx: 0.3,
                            '&:hover': { backgroundColor: 'rgba(59, 130, 246, 0.1)' }
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => archiveDialogOpener(index)}
                          sx={{
                            borderRadius: '10px',
                            color: '#f59e0b',
                            mx: 0.3,
                            '&:hover': { backgroundColor: 'rgba(245, 158, 11, 0.1)' }
                          }}
                        >
                          <ArchiveIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => dialogOpener(index)}
                          sx={{
                            borderRadius: '10px',
                            color: '#ef4444',
                            mx: 0.3,
                            '&:hover': { backgroundColor: 'rgba(239, 68, 68, 0.1)' }
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </AnimatePresence>
            </TableBody>
          </Table>
        </Box>
      </Scrollbar>
      <TablePagination
        component="div"
        count={filteredUsers.length}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[15, 25, 50]}
      />
    </Box>
  );
};

UsersListTable.propTypes = {
  users: PropTypes.array.isRequired
};

export default UsersListTable;
